import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./components/Common/ErrorPage";
import Router from "./routes/Router";
import ToastNotification from "./utils/ToastNotification";
import UserTypeSelectionModal from "./components/UserTypeSelectionModal";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

const theme = createTheme({
  colorSchemes: {
    dark: true,
  },
  palette: {
    dark: {
      light: "#000",
      main: "#000",
      dark: "#fff",
      contrastText: "#fff",
    },
  },
});

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <ErrorBoundary
          FallbackComponent={ErrorPage}
          onReset={() => {}}
          resetKeys={[window.location.href]}
        >
          <ToastNotification />
          <UserTypeSelectionModal />
          <Router />
        </ErrorBoundary>
      </ThemeProvider>
    </>
  );
}

export default App;
